import React from 'react';
import { BaseComponent } from '../BaseComponent.js';
import $ from 'jquery';
import { Line } from 'react-chartjs-2';
import * as zoom from 'chartjs-plugin-zoom-mv';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import 'moment/locale/it';
import FontAwesome from 'react-fontawesome';
import moment from 'moment'

export class TemperatureSensorGraph extends BaseComponent {
  constructor(props) {
    super(props);

    let startDate = moment().subtract(1,'d');
    let endDate = moment(moment().format('YYYY-MM-DD') + ' 23:59:59', "YYYY-MM-DD HH:mm:ss");

    this.state = {
      data: [],
      showGraph: false,
      startDate: startDate,
      endDate: endDate,
      focusedInput: null,
      limit: 1000,
      title: 'Temperature Sensor',
      endpointIndex: this.props.endpointIndex,
    };

    this.filterDate = this.filterDate.bind(this);
  }

  componentDidMount() {
    this.filterDate();
  }

  filterDate(offset) {
    if (isNaN(offset)) {
      offset = 0;
      this.setState({ data: [] });
    } else {
      offset = parseInt(offset, 10) + parseInt(this.state.limit, 10);
    }

    let data = {
      Action: 'GetStoredData',
      DeviceID: this.props.deviceID,
      Offset: offset,
      Queue: 0,
      Limit: this.state.limit,
      //XPath: 'Nodes[IEEEAddress="' + this.state.ieee + '"]'
      XPath: 'Nodes'
    };
    if (this.state.startDate) {
      data.From = parseInt(this.state.startDate.format('X'), 10);
    }
    if (this.state.endDate) {
      let endDate = moment(this.state.endDate.format('YYYY-MM-DD') + ' 23:59:59', "YYYY-MM-DD HH:mm:ss");
      data.To = parseInt(endDate.format('X'), 10);
    }
    data = JSON.stringify(data);

    this.setState({ showGraph: false });

    $.ajax({
      method: 'POST',
      url: 'https://sparkjvm.com/cloud/json',
      headers: {
        'x-session': this.props.token,
      },
      dataType: 'json',
      data: data,
      xhrFields: {
        withCredentials: true
      },
      success: (res) => {
        let i = 0;
        let data = [];
        while (i < res.Data.length) {
          let j = 0;
          while (j < res.Data[i].length) {
            if (res.Data[i][j].IEEEAddress === this.props.ieee) {
              res.Data[i][j].Timestamp = res.Timestamp[i];
              data.push(res.Data[i][j]);
            }
            j++;
          }
          i++;
        }

        // Cerco se ci sono altri dati oltre ai 1000 di limite
        if (res.Limit === res.Count) {
          this.setState({ data: this.state.data.concat(data) });
          this.filterDate(res.Offset);
        } else {
          this.setState({ data: this.state.data.concat(data) });
          this.setState({ showGraph: true });
        }
      },
      error: (httpReq, status, exception) => {
        console.log(httpReq);
        console.log(status);
        console.log(exception);
      },
    });
  }

  renderGraph() {
    if (this.state.showGraph) {
      let i = 0;
      let labels = [];
      let dataTemperatureValue = [];
      let dataHumidityValue = [];

      console.log(this.state.data);

      while (i < this.state.data.length) {
        if (this.state.data[i].Endpoints[this.state.endpointIndex]) {
          if (this.state.data[i].Endpoints[this.state.endpointIndex].TemperatureMeasurement) {
            let measuredValue = this.state.data[i].Endpoints[this.state.endpointIndex].TemperatureMeasurement.MeasuredValue;

            dataTemperatureValue.push(measuredValue/100);
            labels.push(this.timestampToDate(this.state.data[i].Timestamp));
          }

          if (this.state.data[i].Endpoints[this.state.endpointIndex].RelativeHumidityMeasurement) {
            let measuredValue = this.state.data[i].Endpoints[this.state.endpointIndex].RelativeHumidityMeasurement.MeasuredValue;

            dataHumidityValue.push(measuredValue/100);
            labels.push(this.timestampToDate(this.state.data[i].Timestamp));
          }
        }
        i++;
      }

      let dataGraph = {
        labels: labels,
        datasets: [],
      };

      if (dataHumidityValue.length) {
        let obj = {
          label: "Humidity Value",
          data: dataHumidityValue,
          fill: false,
          lineTension: 0.1,
          backgroundColor: '#1faae1',
          borderColor: '#1faae1',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: '#1faae1',
          pointHoverBorderColor: '#1faae1',
          pointBackgroundColor: '#1faae1',
          pointHoverBackgroundColor: '#1faae1',
          pointBorderWidth: 5,
          pointHoverBorderWidth: 5,
          pointRadius: 1,
          pointHoverRadius: 5,
          pointHitRadius: 10,
        };
        dataGraph.datasets.push(obj);
      }

      if (dataTemperatureValue.length) {
        let obj = {
          label: "Temperature Value",
          data: dataTemperatureValue,
          fill: false,
          lineTension: 0.1,
          backgroundColor: '#1faae1',
          borderColor: '#1faae1',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: '#1faae1',
          pointHoverBorderColor: '#1faae1',
          pointBackgroundColor: '#1faae1',
          pointHoverBackgroundColor: '#1faae1',
          pointBorderWidth: 5,
          pointHoverBorderWidth: 5,
          pointRadius: 1,
          pointHoverRadius: 5,
          pointHitRadius: 10,
        };
        dataGraph.datasets.push(obj);
      }
      let options = {
        zoom: {
          enabled: true,
          mode: 'x'
        },
      };

      return(
        <div className="graphs__content">
          <div className="graphs__content__search">
            <div className="graphs__content__search__inside">
              <DateRangePicker
                startDatePlaceholderText="Da"
                endDatePlaceholderText="A"
                startDate={this.state.startDate}
                startDateId="date_from"
                endDate={this.state.endDate}
                endDateId="date_to"
                onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
                focusedInput={this.state.focusedInput}
                onFocusChange={focusedInput => this.setState({ focusedInput })}
                hideKeyboardShortcutsPanel={true}
                isOutsideRange={() => false}
                minimumNights={0}
              />
              <button className="button" onClick={ this.filterDate }>FILTRA</button>
            </div>
          </div>
          <Line data={ dataGraph } options={ options } />
        </div>
      )
    }

    return(
      <div className="graphs__content">
        <div className="graphs__content__inside graphs__content__inside--search">
          Caricamento dati <FontAwesome name='spinner' spin />
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="graphs">
        <div className="graphs__topbar">{ this.state.title }</div>
        { this.renderGraph() }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/graphs/TemperatureSensorGraph.js